<app-table
  *ngIf="cols && compositions"
  [cols]="cols"
  [elements]="compositions"
  modelName="composições"
  sortField="compositionId"
  [sortOrder]="1"
  [lazy]="false"
></app-table>
